export default "__VITE_ASSET__qjYlFf3Y__"